/**
 * $ Timer doesn't natively act like a stopwatch, it only
 * aids in building one.  You need to keep track of the current
 * time in a variable and increment it manually.  Then on each
 * incrementation, update the page.
 *
 * The increment time for $ Timer is in milliseconds. So an
 * input time of 1000 would equal 1 time per second.  In this
 * example we use an increment time of 70 which is roughly 14
 * times per second.  You can adjust your timer if you wish.
 *
 * The update function converts the current time to minutes,
 * seconds and hundredths of a second.  It then outputs that to
 * the stopwatch element, stopwatch, and then increments. Since
 * the current time is stored in hundredths of a second so the
 * increment time must be divided by ten.
 */
var GameTimerYashVariables = {
  stopwatch: null,
  Timer: null,
  incrementTime: null,
  currentTime: null,
  submitTime: null,
  warningTime: null,
  startTime: null,
  sectionLength: null,
  needToDisplayWarning: null,
  overtime: null,
  currentQuestion: null,

}

//EXAMPLE 1
class GameTimerYash {
  constructor(currentQuestion, stopwatch) {
    //Initialize variables
    GameTimerYashVariables.stopwatch = null;
    GameTimerYashVariables.Timer = null;
    GameTimerYashVariables.incrementTime = 200; // Timer speed in milliseconds
    GameTimerYashVariables.currentTime = 0; // Current time in hundredths of a second
    GameTimerYashVariables.submitTime = 35; // shutdown & score time in minutes
    GameTimerYashVariables.warningTime = 30;
    GameTimerYashVariables.startTime = 0;
    GameTimerYashVariables.sectionLength = 35 * 60 * 100; //number of minutes * seconds per minute * 100 centiseconds per second ? ? ? ?? ? ? ? ? ? ? ? ? ?? ? ?
    GameTimerYashVariables.needToDisplayWarning = true;
    GameTimerYashVariables.overtime = false;
    GameTimerYashVariables.currentQuestion = currentQuestion;

    this.init();
  }

  updateTimer() {
    if (GameTimerYashVariables.overtime)
      GameTimerYashVariables.stopwatch.html(afterDeadlineTime(GameTimerYashVariables.currentTime, GameTimerYashVariables.sectionLength));
    else
      GameTimerYashVariables.stopwatch.html(inverseTime(formatTime(GameTimerYashVariables.currentTime), GameTimerYashVariables.sectionLength));

    GameTimerYashVariables.stopwatch.attr("data-clock", GameTimerYashVariables.currentTime / 100);

    //automatic submit
    if (GameTimerYashVariables.currentTime / 100 > GameTimerYashVariables.submitTime * 60) {                    // if timer exceeds reset time
      $("#submit-yash").trigger("click");
    }

    if (GameTimerYashVariables.startTime == 0) {
      GameTimerYashVariables.startTime = (new Date().getTime()) - GameTimerYashVariables.incrementTime;
      GameTimerYashVariables.currentQuestion.startTime = GameTimerYashVariables.startTime;
    }
    GameTimerYashVariables.currentTime = ((new Date().getTime()) - GameTimerYashVariables.startTime) / 10;

    //update progress bar
    if (GameTimerYashVariables.needToDisplayWarning && GameTimerYashVariables.currentTime >= (GameTimerYashVariables.warningTime * 60 * 100)) {
      $('.interface-progress-percent-yash').css('backgroundColor', 'red');
      $('#interface-modal-warning-container-yash').css('display', 'flex');

      var interfaceTimer = $(".interface-timer-yash");
      if (interfaceTimer.attr('data-show') == 0) {
        interfaceTimer.click();
      }
      $(".interface-timer-yash").off('click');
      $(".interface-timer-yash").css("cursor", "default");

      GameTimerYashVariables.needToDisplayWarning = false;
    }
    var widthDecimal = 100 - (((GameTimerYashVariables.sectionLength * 60 * 100) - GameTimerYashVariables.currentTime) / (GameTimerYashVariables.sectionLength * 60 * 100)) * 100;
    if (widthDecimal > 100) {
      widthDecimal = 100;
    }
    var widthPercent = widthDecimal + '%';
    $('.interface-progress-percent-yash').css('width', widthPercent);

    //update progress bar to overtime
    if (GameTimerYashVariables.overtime == false && GameTimerYashVariables.currentTime > (GameTimerYashVariables.sectionLength * 60 * 100)) {
      //display modal
      $('#interface-modal-warning-container-yash').remove();
      if (GameTimerYashVariables.submitTime !== GameTimerYashVariables.sectionLength)
        $('#interface-modal-timeup-container-yash').css('display', 'flex');

      //change bar
      $('.interface-timer-yash').css('color', 'red');
      $('#stopwatch-yash').css('color', 'red');
      $(".time-words-text").html("Time Over:");

      GameTimerYashVariables.overtime = true;
    }
  }
  init() {
    GameTimerYashVariables.stopwatch = $('#stopwatch-yash');
    GameTimerYashVariables.submitTime = $('#submit-yash').attr("data-submit-time");
    GameTimerYashVariables.warningTime = $('#submit-yash').attr("data-warning-time");
    GameTimerYashVariables.sectionLength = $('#submit-yash').attr("data-section-length");
    if (document.querySelector('#stopwatch-yash') !== null)
      GameTimerYashVariables.Timer = jQuery.timer(this.updateTimer, GameTimerYashVariables.incrementTime, false);
    GameTimerYashVariables.currentQuestion.startTime = new Date().getTime();

    GameTimerYashVariables.Timer.toggle();
  }
  stopTimer() {
    GameTimerYashVariables.Timer.toggle();
  }

  // function captureTime()
  //         {
  //         /**** Calculation time start here ***********/
  //         // var ttaken = this.keyarr("#stopwatch").html();  /***** getting time form stop watch *******/
  //         //         var ttaken_s1 = ttaken.substr(0, 2);    /***** getting mins from time *******/
  //         //                 ttaken_s1 = ttaken_s1 * 60;     /******* converting mins to seconds *******/
  //         //         var ttaken_s2 = ttaken.substr(3, 2);    /***** getting secs from time *******/
  //         //         var ttaken_n =  ttaken_s1 + parseInt(ttaken_s2);    /******getting total secs *****/
  //         //         var ttaken_new = ttaken_n - ttaken_old;     /**** getting total time taken ******/

  //         //         var exist_value = this.keyarr(".lsat-question-selected").attr('data-time');  ***** getting previous time taken by user for that same question ****
  //         //         var exist_value_new = exist_value;

  //         //         var ttaken_total = parseInt(ttaken_new) + parseInt(exist_value_new);
  //         //         var datatbid = this.keyarr(".lsat-question-selected").attr("question-sequence");
  //         //         var data_time_attr = this.keyarr(".lsat-question-selected").attr("data-time");
  //         //         this.keyarr("#t"+datatbid).html(ttaken_total);
  //         //         this.keyarr(".lsat-question-selected").attr('data-time', ttaken_total);
  //         //         ttaken_old = ttaken_n;
  //         //         this.keyarr("#time-spent-"+datatbid).val(ttaken_total);
  //         //         /******** calculation time end here *********/
  //         }

  resetStopwatch() {
    GameTimerYashVariables.currentTime = 0;
    GameTimerYashVariables.Timer.stop().once();
  };
}

// Ensure GameTimerYash is available on window for other scripts
if (typeof window !== 'undefined') {
  window.GameTimerYash = GameTimerYash;
}

// Common functions
function pad(number, length) {
  var str = '' + number;
  while (str.length < length) { str = '0' + str; }
  return str;
}

function formatTime(time) {
  var min = parseInt(time / 6000),
    sec = parseInt(time / 100) - (min * 60);
  // hundredths = pad(time - (sec * 100) - (min * 6000), 2);
  return (min > 0 ? pad(min, 2) : "00") + ":" + pad(sec, 2);
}

//to make the time count down instead of count up
function inverseTime(time, sectionLength) {
  var minutesAndSeconds = time.split(":");
  var minutes = parseInt(minutesAndSeconds[0]);
  var seconds = parseInt(minutesAndSeconds[1]);

  minutes = sectionLength - minutes - 1;
  seconds = 59 - seconds;

  return (minutes > 0 ? pad(minutes, 2) : "00") + ":" + (minutes > -1 ? pad(seconds, 2) : "00");
}

function afterDeadlineTime(time, sectionLength) {
  var min = parseInt((time / 6000) - sectionLength),
    sec = parseInt(time / 100) - (min * 60) - (sectionLength * 60);

  return (min > 0 ? pad(min, 2) : "00") + ":" + pad(sec, 2);
}

//once the test taker reaches submit time
// function inverseTime(time, sectionLength) {
//     var minutesAndSeconds = time.split(":");
//     var minutes = parseInt(minutesAndSeconds[0]);
//     var seconds = parseInt(minutesAndSeconds[1]);

//     minutes = sectionLength - minutes - 1;
//     seconds = 59 - seconds;

//     return (minutes > 0 ? pad(minutes, 2) : "00") + ":" + (minutes > -1 ? pad(seconds, 2) : "00");
// }


// function playLessonVideo(videoPlayer, videoName) {
//   videoPlayer.src({
//     src: 'https://cdn.lsatengine.com/lessons/' + videoName + '/' + videoName + '.m3u8',
//     type: 'application/x-mpegURL',
//     withCredentials: true
//   });
//   videoPlayer.volume(0.5);
// }
// //https://cdn.lsatengine.com/explanations/<%= @preptest_number %>/<%= @filename %>/<%= @filename %>.m3u8
// function playExplanationVideo(videoPlayer, preptestNumber, fileName) {
//   videoPlayer.src({
//     src: 'https://cdn.lsatengine.com/explanations/' + preptestNumber + '/' + fileName + '/' + fileName + '.m3u8',
//     type: 'application/x-mpegURL',
//     withCredentials: true
//   });
//   videoPlayer.volume(0.5);
// }